export default "<div ng-class=\"::$ctrl.style.container\">\n  <es-tracking-rating es-rating=\"$ctrl.esRating\"></es-tracking-rating>\n</div>\n"